import { Notification } from "@novu/react";
import has from "lodash/has";

import { CommentData, NotificationPayloadActor, RequestLicenseData, TypedNotification } from "./types";

export function getLegacyCommentSubject(notification: Notification): string | null {
  const regex = /<h5>(?<subject>.*)<\/h5>/;
  const matches = notification.body.match(regex);
  if (matches !== null) {
    return matches?.groups?.subject ?? matches[1] ?? "";
  }
  return null;
}

export function getLegacyCommentBody(notification: Notification): string | null {
  const regex = /<blockquote>(?<body>.*)<\/blockquote>/;
  const matches = notification.body.match(regex);
  if (matches !== null) {
    return matches?.groups?.body ?? matches[1] ?? "";
  }
  return null;
}
export function getLegacyActorName(notification: Notification): string | null {
  const subjectRegex = /^(?<name>.*) (has requested|replied to you|commented on)/;
  const bodyRegex = /<h5>(?<name>.*) (has requested|replied to you|commented on)/;
  const subjectMatches = notification.subject?.match(subjectRegex) ?? null;
  const bodyMatches = notification.body.match(bodyRegex);
  if (subjectMatches !== null) {
    return subjectMatches?.groups?.name ?? subjectMatches[1] ?? "";
  }
  if (bodyMatches !== null) {
    return bodyMatches?.groups?.name ?? bodyMatches[1] ?? "";
  }
  return null;
}

export function isLegacyCommentNotification(notification: Notification): boolean {
  return notification.workflow?.identifier === "new-comment" || notification.workflow?.identifier === "new-comment-mention";
}

export function isLegacyRequestLicenseNotification(notification: Notification): boolean {
  return notification.workflow?.identifier === "request-license";
}

export function isRequestLicenseNotification(notification: Notification): notification is TypedNotification<RequestLicenseData> {
  return notification.workflow?.identifier === "request-license-v2";
}

export function isCommentNotification(notification: Notification): notification is TypedNotification<CommentData> {
  return notification.workflow?.identifier === "comment";
}

export function isMentionNotification(notification: Notification): notification is TypedNotification<CommentData> {
  return notification.workflow?.identifier === "mention";
}

export function hasNotificationActor(notification: Notification): notification is TypedNotification<NotificationPayloadActor> {
  return has(notification, "data.UserFirstName") && has(notification, "data.UserLastName");
}
